module.exports = __webpack_public_path__ + "img/71.d5993060.png";